import Vue from 'vue'
import App from './App.vue'
import router from './router/router'
import 'lib-flexible';
import common from './components/commonComponents/com.js' //  全局注册自定义组件
import element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css' //  element字体色调
import './assets/css/element-variables.scss' // 默认主题
import axios from './axios/axios.js' //  请求响应拦截
import urls from './axios/serviceUrls' //  请求url地址
import store from './store'
import Messages from './utils/message.js'
import comforms from './utils/comforms.js';
import directive from '@/directive/el-input/index.js';
import Blob from "./utils/Blob.js";
import Export2Excel from "./utils/Export2Excel.js";
// 自定义全局样式
import base from './assets/css/base.less'
// wangEditor
import 'wangeditor'
require('./mock.js')


Vue.config.productionTip = false
Vue.use(common)
Vue.use(comforms)
Vue.use(element);
Vue.use(directive);
Vue.prototype.$axios = axios
Vue.prototype.$url = urls
Vue.prototype.$Messages = Messages;


router.beforeEach((to, from, next) => {
    // console.log(to)
    // console.log(from)
    if (to.name === null) {
        from.name ? next({
            name: from.name
        }) : next('/404')
    } else if (to.name === 'login') {
        
        next()
    } else {
        next()
    }
})
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')